/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

import Batcher from './batcher';

const ClientMetricsBatcher = Batcher.extend({
  namespace: 'Metrics',

  prepareItem(item) {
    // Add more defaults to payload when the clientmetrics endpoint evolves to support richer payloads
    return Promise.resolve(item);
  },

  prepareRequest(queue) {
    return Promise.resolve(queue);
  },

  submitHttpRequest(payload) {
    return this.webex.request({
      method: 'POST',
      service: 'metrics',
      resource: 'clientmetrics',
      body: {
        metrics: payload,
      },
      waitForServiceTimeout: this.webex.config.metrics.waitForServiceTimeout,
    });
  },
});

export default ClientMetricsBatcher;
